import {Search2Icon} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Checkbox,
  HStack,
  Input,
  Select,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr,
  useToast
} from '@chakra-ui/react'
import React, {useState} from "react";
import {useMutation, useQuery, useQueryClient} from "react-query";

import {getJudges} from "../../shared/Api";
import {errorToast, successToast} from "../../shared/helper/ToastHelper";
import {UserStatus} from "../../shared/model/Constants";
import {UserDto} from "../../shared/model/Dto";
import {adminKeys} from "../../shared/QueryKeys";
import {extractData, includedInFilter} from "../../shared/Utils";
import JudgeSummaryItem from "./JudgeSummaryItem";
import UploadExcelFeedback from "./UploadExcelFeedback";

const JudgesList = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  const [institutionValue, setInstitutionValue] = useState<string>("");
  const [regionValue, setRegionValue] = useState<string>("");
  const [groupValue, setGroupValue] = useState<string>("");

  const [idValue, setIdValue] = useState<string>("");
  const [nameValue, setNameValue] = useState<string>("");
  const [emailValue, setEmailValue] = useState<string>("");
  const [emailSecondValue, setEmailSecondValue] = useState<string>("");
  const [revisionCodeValue, setRevisionCodeValue] = useState<string>("");

  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(25);

  const usersQuery = useQuery(adminKeys.users(), () =>
    getJudges(idValue, nameValue,
        institutionValue, regionValue, groupValue,
        emailValue, emailSecondValue, revisionCodeValue
        ).then(extractData)
  );

  if (!usersQuery.data) {
    return (
      <Center height="200px">
        <Spinner />
      </Center>
    );
  } else {
    return (
      <Box width="95%" marginX="auto">

          <UploadExcelFeedback />

          <HStack alignSelf="start" spacing={10} paddingY={1}>
            <Input placeholder='Identificación' onChange={(event)=>setIdValue(event.target.value)}/>
            <Input placeholder='Nombre' onChange={(event)=>setNameValue(event.target.value)} />
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={1}>
            <Input placeholder='Institución' onChange={(event)=>setInstitutionValue(event.target.value)}/>
            <Input placeholder='Región' onChange={(event)=>setRegionValue(event.target.value)} />
            <Input placeholder='Grupo' onChange={(event)=> setGroupValue(event.target.value)}/>
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={1}>
            <Input placeholder='Código de revisión' onChange={(event)=>setRevisionCodeValue(event.target.value)}/>
            <Input placeholder='Correo' onChange={(event)=>setEmailValue(event.target.value)} />
            <Input placeholder='Correo Secundario' onChange={(event)=> setEmailSecondValue(event.target.value)}/>
          </HStack >

          <HStack alignSelf="start" spacing={10} paddingY={1}>
            <Select value={pageSize.toString()} isReadOnly={true} width="1xs"
                    onChange={(event)=> {setPageSize(parseInt(event.target.value)); }}>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              {/*<option value={(usersQuery.data).length}>Todos</option> */}
            </Select>

            <Button leftIcon={<Search2Icon />} colorScheme="teal" onClick={()=> {
              setPage(0);
              return usersQuery.refetch();
            }}
                    disabled={usersQuery.isFetching}>
              Buscar
            </Button>

            {usersQuery.isFetching &&
              <Spinner />
            }
          </HStack >

        <TableContainer width="95vw">
        <Table size='sm' variant='striped' whiteSpace="normal">
          <Thead>
            <Tr>
              <Th>Identificación</Th>
              <Th>Nombre</Th>
              <Th>Institución</Th>
              <Th>Región</Th>
              <Th>Correo</Th>
              <Th>Correo Secundario</Th>
              <Th>Grupo</Th>
              <Th>Código de revisión</Th>
              <Th>Editar</Th>
            </Tr>
          </Thead>

          <Tbody key="List">
              {usersQuery.isSuccess && usersQuery.data.length ? (
                (usersQuery.data).slice(page, page+pageSize).map((user) => (
                  <JudgeSummaryItem user={user} />
                ))
              ) : (
                <Tr key={"empty"}>
                </Tr>
              )}
          </Tbody>
        </Table>
      </TableContainer>
        <HStack paddingY={10} justifyContent="end">
          <Button
            colorScheme="teal"
            disabled={page === 0}
            onClick={()=>setPage(page-pageSize)}
          >
            Anterior
          </Button>
          <Button
            colorScheme="teal"
            disabled={!usersQuery.data || page+pageSize >= (usersQuery.data).length}
            onClick={()=>setPage(page+pageSize)}
          >
            Siguiente
          </Button>
        </HStack>
      </Box>
    );
  }
};

export default JudgesList;
